<section  class="cz-user-details-equipment" [ngClass]="{'container-fluid': !readonly && !esppId}">
  <!--Expando header for evaluation view-->
  <mat-expansion-panel [expanded]="false" *ngIf="esppId">
    <mat-expansion-panel-header>
      <mat-panel-title class="truncate">
          <span class="truncate" [innerHTML]="'$equipment_list_title_label' | translate"></span>
      </mat-panel-title>
      <mat-panel-description>
        <mat-checkbox labelPosition="before" 
                      (click)="stopPropagation($event)" 
                      (change)="headerCheckboxChecked($event)"
                      [checked]="headerCheckedState">
          <span [innerHTML]="'$evaluation_add_to_report_label' | translate"></span>
        </mat-checkbox>
      </mat-panel-description>
    </mat-expansion-panel-header>
    <!--Equipment list content area-->
    <div class="container main-content">
      <div class="equipment-recommendation-panels has-scrolling-list">
        <!-- Installed equipment -->
        <cz-workflows-view *ngIf="installedEquipment$ | async as installedWorkflows"
                                    [workflowList]="installedWorkflows"
                                    [userId]="userId"
                                    [esppId]="esppId"
                                    [viewState]="installedViewState"
                                    [readonly]="readonly"
                                    [authUser]="loggedInUser"></cz-workflows-view>

        <!-- Recommended equipment -->
        <cz-workflows-view *ngIf="recommendedEquipment$ | async as recommendedWorkflows"
                                      [workflowList]="recommendedWorkflows"
                                      [userId]="userId"
                                      [esppId]="esppId"
                                      [viewState]="recommendedViewState"
                                      [readonly]="readonly"
                                      [authUser]="loggedInUser"></cz-workflows-view>
      </div>
    </div>
  </mat-expansion-panel>
  <!--Regular header for user details and my-zone views-->
  <mat-toolbar color="primary" class="section-header" *ngIf="!esppId">
    <mat-toolbar-row>
      <span class="truncate" [innerHTML]="'$equipment_list_title_label' | translate"></span>
    </mat-toolbar-row>
  </mat-toolbar>
  <!--Equipment list content area-->
  <div class="container main-content" *ngIf="!esppId">
    <div class="row">
      <div class="col-xs">
        <p [innerHTML]="'$equipment_list_description_label' | translate"></p>
      </div>
    </div>
    <div class="equipment-recommendation-panels has-scrolling-list">
      <!-- Installed equipment -->
      <cz-workflows-view *ngIf="installedEquipment$ | async as installedWorkflows"
                                  [workflowList]="installedWorkflows"
                                  [userId]="userId"
                                  [esppId]="esppId"
                                  [viewState]="installedViewState"
                                  [readonly]="readonly"
                                  [authUser]="loggedInUser"></cz-workflows-view>

      <!-- Recommended equipment -->
      <cz-workflows-view *ngIf="recommendedEquipment$ | async as recommendedWorkflows"
                                    [workflowList]="recommendedWorkflows"
                                    [userId]="userId"
                                    [esppId]="esppId"
                                    [viewState]="recommendedViewState"
                                    [readonly]="readonly"
                                    [authUser]="loggedInUser"></cz-workflows-view>
      </div>
    </div>
</section>